import type {ReactNode} from 'react'
import {PromoCards} from '../../../layout/promo_cards/PromoCards'
import type {CabinetMenuType} from '../CabinetSharedTypes'
import {CabinetFinancesSideMenu} from './CabinetFinancesSideMenu'
import {CabinetSideMenu} from './CabinetSideMenu'

interface Props {
    type: CabinetMenuType
}

// Меню для ЛК.
export function CabinetMenu(props: Props) {

    const {
        type,
    } = props

    let menu: ReactNode | null = null
    switch (type) {
        case 'finances':
            menu = <CabinetFinancesSideMenu key="finances" />
            break
        case 'profile':
            menu = <CabinetSideMenu key="profile" />
            break
        default:
            return null
    }

    return (
        <div
            id="cabinet-sidebar-container"
            className="d-flex gap-4 flex-column align-items-stretch"
        >
            <div
                id="cabinet-side-menu"
                className="d-flex gap-3 flex-column align-items-stretch"
            >
                {menu}
            </div>
            <PromoCards
                className="d-none d-lg-grid"
                utmSource="cabinet_side_menu"
            />
        </div>
    )
}
